<template>
  <v-menu class="menu" width="100%" transition="slide-x-transition" offset-y right offset-overflow>
    <template v-slot:activator="{ on }">
      <div class="menu-notification" v-on="on">
        <div class="menu-notification_wrap">
          <BaseIcon color="#f2f2f2" icon="pages-settings-push_notifications" />
          <div
            v-if="countNewNotifications"
            :data-text="countNewNotifications"
            class="menu-notification_badge f12"
          />
        </div>
      </div>
    </template>
    <HeaderNotificationList :notifications="notificationUserGrid" />
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HeaderNotificationList from 'components/header/notification/HeaderNotificationList'
export default {
  name: 'HeaderNotification',
  components: {
    HeaderNotificationList,
  },
  data() {
    return {
      firstLoad: false,
    }
  },
  created() {
    this.onNotificationUserGrid({}).then(()=> this.firstLoad = true)
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  computed: {
    ...mapGetters('notificationUser', ['notificationUserGrid']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    userData() {
      return this.$store.getters['user/userData']
    },
    countNewNotifications() {
      return this.notificationUserGrid.filter((i) => !i.is_seen).length
    },
  },
  methods: {
    ...mapActions('notificationUser', ['onNotificationUserGrid']),
    onVisibilityChange() {
      if (this.firstLoad && document.visibilityState === 'visible') {
        this.onNotificationUserGrid({})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.abs {
  position: absolute;
}
.menu-notification {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &_wrap {
    position: relative;
    line-height: 0;
  }
  &_badge {
    position: absolute;
    left: 60%;
    top: 20%;
    transform: translateY(-50%);
    &::before {
      background: #f2f2f2;
      border-radius: 50%;
      min-width: 22px;
      content: attr(data-text);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 3px;
      color: #333333;
      border: 2px solid #277faf;
    }
  }
  &:hover {
    background-color: #3d8cb7;
  }
}
.v-menu__content {
  max-width: 90%;
  filter: drop-shadow(0px 4px 4px rgba(168, 169, 170, 0.2));
  box-shadow: none;
  border-radius: 0px 0px 10px 10px !important;
  overflow: hidden;
  background: #f2f2f2;
    @media screen and (max-width: 380px) {
    max-width: 100%;
  }
}
</style>
